// extracted by mini-css-extract-plugin
export default {"wrapper":"MiniSearchB2bStyle_wrapper__bbjzr"};